import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Curing extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_bud_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Curing
        </h2>
        <p>
        <span className="highlight">Timeline: 3 weeks to 3 months</span>
        </p>
        <p>
        Once your buds are dried and trimmed they are smokeable. However letting them cure for a few weeks will improve the flavor and remove any remaining grass taste. To begin curing place your buds into glass mason jars, screw on the lid, and put them somewhere dark. Make sure to label your jars. The optimal humidity for curing is 59 - 67% RH. Check on them once or twice a day and burp the jars, which means opening them briefly to get some fresh air. If your marijuana buds ever get too moist, unscrew the lid and let the bud air out for an hour or two. Curing can take anywhere from 3 weeks to 3 months so be patient. Check your bud daily until it achieves a nice balance of sticky and dry. 
        </p>
        <p>
        After curing, you’re done! Sit back, relax and enjoy your harvest. 
        </p>
        <GuideButton slugTo="part-three-introduction" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_curing.js